export enum HeadingLevelEnum {
  H1 = "h1",
  H2 = "h2",
  H3 = "h3",
  H4 = "h4",
}

export enum HeadingSizeEnum {
  LG = "lg",
  XL = "xl",
  XXL = "2xl",
  HERO_SM = "hero-sm",
  HERO = "hero",
}

export enum HeadingAlignmentEnum {
  LEFT = "left",
  CENTER = "center",
  RIGHT = "right",
}
